
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import Axios from 'axios';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';

@Component({
  components: {
    SweetModal,
  },
  mixins: [ Clickaway ],
})

export default class AttachPackage extends Vue {
  @Prop()
    mod!: any[];
  @Prop()
    items!: any[];

  indexList: number[] = [];
  allChecked = false;
  searchQuery: string = '';
  localModuleItems: any[] = [];
  modules: any[] = [];
  selectedModuleid: number = -1;

  @Watch('items')
    setFullResponseFromProps() {
      // @ts-ignore
      this.localModuleItems = JSON.parse(JSON.stringify(this.items));
  }

  @Watch('mod.length')
    setModuleFromProps() {
      this.modules = this.mod;
  }

  // updateCheck(index: number) {
  //   this.indexList.push(index);
  // }

  search() {
    this.$emit('search', this.searchQuery);
  }

  moduleSelected(id: number, t: string) {
    if (this.selectedModuleid !== id) {
      this.selectedModuleid = id;
      this.indexList = [];
      this.$emit('moduleSelected', {id: this.selectedModuleid, type: t});
    }
  }

  save() {
    this.cancel();
    this.$emit('save', this.indexList);
    this.indexList = [];
    this.allChecked = false;
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }

  checkAll() {
    if (!this.allChecked) {
      this.indexList = [];
      // @ts-ignore
      for (const iterator of this.localModuleItems) {
        if (iterator.id) {
          this.indexList.push(iterator.id);
        }
      }
      this.allChecked = true;
    } else {
      this.indexList = [];
      this.allChecked = false;
    }
  }

  updateCheck() {
      if (this.indexList.length === this.localModuleItems.length) {
         this.allChecked = true;
      } else {
         this.allChecked = false;
      }
  }
}
